import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class NonGovermentUniformInvoiceCheckService {

  constructor(private http: HttpClient) { }

  searchNonGovermentInvoice(request: any): Observable<any> {
    const url = `${environment.expenseApiUrl}/nonGovermentUniformInvoice/searchInvoice`;
    return this.http.post(url, request);
  }


  getNonGovermentUniformInvoiceExcel(param: any): Observable<any> {
    const url = `${environment.expenseApiUrl}/nonGovermentUniformInvoice/nonGovermentUniformInvoiceExcel/bulk`;
    return this.http.post(url, param, { responseType: 'blob' });
  }

  importNonGovermentUniformInvoiceByExcel(file: any, facility: any, createUser: any): Observable<any> {
    const url = `${environment.expenseApiUrl}/nonGovermentUniformInvoice/nonGovermentUniformInvoiceExcel/bulk`;
    const formData: FormData = new FormData();
    formData.append('file', file, file.name);
    formData.append('facility', facility);
    formData.append('createUser', createUser);
    let response = this.http.put(url, formData);
    return response;
  }


  searchNonGovermentInvoiceDetail(request: any): Observable<any> {
    const url = `${environment.expenseApiUrl}/nonGovermentUniformInvoice/searchInvoiceDetail`;
    return this.http.post(url, request);
  }

  updateNonGovermentUniformInvoice(updateList: any): Observable<any> {
    const url = `${environment.expenseApiUrl}/nonGovermentUniformInvoice/updateInvoice`;
    return this.http.post(url, updateList);
  }

  approveNonGovermentUniformInvoice(updateObj: any): Observable<any> {
    const url = `${environment.expenseApiUrl}/paymentApplication/noGui/approve`;
    return this.http.put(url, updateObj);
  }

  addNonGovermentUniformInvoice(updateObj: any): Observable<any> {
    const url = `${environment.expenseApiUrl}/paymentApplication/noGui/addGuiNo`;
    return this.http.post(url, updateObj);
  }

  rejectNonGovermentUniformInvoice(updateObj: any): Observable<any> {
    const url = `${environment.expenseApiUrl}/paymentApplication/noGui/reject`;
    return this.http.put(url, updateObj);
  }
}
